



























import { auth, collections, firestore } from "@/configs/firebase";
import { objectify } from "@/helpers";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class DoctorNomination extends Vue {
  @Prop() lead!: any;
  valid = true;
  firstName = "";
  lastName = "";
  details = "";

  nameRules = [(v: string) => !!v || "This field is required"];

  submit() {
    //@ts-ignore
    const isValid = this.$refs.form.validate();
    if (isValid) {
      try {
        collections.doctorNominations.add({
          created_ts: firestore.Timestamp.now(),
          first_name: this.firstName,
          last_name: this.lastName,
          details: this.details,
          nominated_by: objectify(auth().currentUser).email,
          lead_id: objectify(this.lead).id,
          submitted: false
        });
        //@ts-ignore
        this.$refs.form.reset();
        this.$toasted.success("Nomination successfully sent!").goAway(2000);
      } catch (err) {
        console.log("doctor nomination error:", err);
        this.$toasted.error("Nomination failed").goAway(2000);
      }
    }
  }
}
